import * as webMercatorUtils from '@arcgis/core/geometry/support/webMercatorUtils.js';
import { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Box } from '@rsos/components/capstone/base';
import { setTemporaryLocation } from '@rsos/reduxDataStore/src/features/airAmbulance/airAmbulanceSlice';
import { needsWebMercatorConversion } from '../../../../utils/needsWebMercatorConversion';
import {
  ResultWrapper,
  StyledPlaceName,
  StyledSecondaryAddr,
} from './AddressSearchInput.styled';

const WORLD = 'World';
function memoed(prevProps, nextProps) {
  // If using Gis format
  if (prevProps?.address?.attributes) {
    return (
      prevProps?.address?.attributes?.LongLabel ===
      nextProps?.address?.attributes?.LongLabel
    );
  }
  // If using Google format
  return prevProps?.address?.address === nextProps?.address?.address;
}

export const SuggestedAddress = memo(
  ({ index, address, handleSelectSuggestion, setSelectedSuggestionIndex }) => {
    const dispatch = useDispatch();
    const isGisFormat = address?.attributes !== undefined;
    let displayAddress = '';
    let secondaryAddress = '';

    if (isGisFormat) {
      const {
        PlaceName = '',
        StAddr = '',
        City = '',
        Loc_name = '',
        RegionAbbr = '',
        Postal = '',
        MetroArea = '',
        Region = '',
        Zone = '',
        Place_addr = '',
      } = address.attributes;

      const isGlobalFormat = Loc_name === WORLD;

      let regionalAdd = `${MetroArea}, ${Region} ${Zone}`;

      if (isGlobalFormat) {
        regionalAdd = `${City}, ${RegionAbbr} ${Postal}`;
        if (!City) {
          regionalAdd = `${RegionAbbr} ${Postal}`;
        }
      } else if (!MetroArea) {
        regionalAdd = `${Region} ${Zone}`;
      }

      displayAddress = PlaceName || StAddr || regionalAdd;
      secondaryAddress = Place_addr;
    } else {
      // Handle Google format
      const addressParts = address.address.split(',');
      displayAddress = addressParts[0].trim(); // Street address
      secondaryAddress = addressParts.slice(1).join(',').trim(); // City, State ZIP
    }

    const handleHover = e => {
      setSelectedSuggestionIndex(e);

      if (address.location?.x && address.location?.y) {
        const { x, y } = address.location;
        const [lng, lat] = needsWebMercatorConversion(x, y)
          ? webMercatorUtils.xyToLngLat(x, y)
          : [x, y];

        dispatch(
          setTemporaryLocation({
            latitude: lat,
            longitude: lng,
          }),
        );
      }
    };
    const resetHover = useCallback(() => {
      dispatch(setTemporaryLocation(null));
    }, [dispatch]);

    return (
      <ResultWrapper
        onClick={() => {
          handleSelectSuggestion(address);
        }}
        key={index}
        onMouseEnter={e => handleHover(e)}
        onMouseLeave={resetHover}
      >
        <Box horizontal p="0" m="0">
          <Box p="0" m="0">
            <StyledPlaceName>{displayAddress}</StyledPlaceName>
            {secondaryAddress && (
              <StyledSecondaryAddr>{secondaryAddress}</StyledSecondaryAddr>
            )}
          </Box>
        </Box>
      </ResultWrapper>
    );
  },
  memoed,
);
